import d3 from "./d3.min.js";
import {
    splitbar
} from "./splitBar.js";
import {
    returnedBounds,
    initialMap,
    updateMap,
    makeLegend,
    updateLegend,
} from "./statemap.js";

// console.log("splitbar", splitbar);
d3.selection.prototype.moveToFront = function () {
    return this.each(function () {
        this.parentNode.appendChild(this);
    });
};

// Define the explicit order

//for pies, these go in last to first order-e xcept race
const sortOrderEC1 = [
    //  "Screening not completed",
    "Positive/Not normal result",
    "Negative/Normal result",
    ];
    

const sortOrderMono = [
  "Screening not completed",
  "Positive/Not normal result",
  "Negative/Normal result",
];
const sortOrdert1d = [
  "No response provided",
  "Higher concern",
  "Moderate concern",
  "Low concern",
];
const sortOrderPanel = [
  "Group 1 only",
  "Group 1 & 2",
  "Group 1 & T1D",
  "Group 1,2 & T1D",
];

const sortOrderRace = [
  "American Indian of Alaska Native",
  "Asian",
  "Black, African American, or African",
  "Hispanic, Latino, or Spanish",
  "Middle Eastern or North African",
  "Native Hawaiian or Pacific Islander",
  "White",
  "More than one race and/or ethnicity",
  "Unknown",
];

async function getdata() {
    const countFormat = d3.format(",.0f");
    const pctFormat = d3.format(".1%");

    const d3data = await d3
        .csv(
            window.location.origin +
            "/themes/earlycheck/staticData/EC_data10172024.csv"
        )
        .then((data) => data);
    //   console.log("d3data", d3data);
    //colors go clockwise

    let raceRange = [
    "pink",
    "#b24e0a",
    "#94C6CE",
    "#1C843C",
    "purple",
    "gray",
    "#005663",
    "#F0B66F",
    "#aa973c",
  ];
    // omits 'two or more ' color
    let raceRange2 = [
    "pink",
    "#b24e0a",
    "#94C6CE",
    "#1C843C",
    "purple",
    "gray",
    "#005663",
    "#aa973c",
  ];
    let monoRange = ["#aa973c", "#e647e0", "#afd8db"];
    let EC1Range = ["#e647e0", "#afd8db"];
    //mono with inconclusive
    //let monoRange = ["#e6e6e6","#aa973c", "#e647e0", "#afd8db"];
    let t1dRange = ["#aa973c", "#ed9c23", "#f7d16a", "#afd8db"];
    let panelRange = ["#59a5b1", "#f7d16a", "#afd8db", "#005663"];

    function PreppedPanelData(fulldata) {
        //dont include conditions data for pies
        let filtered = fulldata.filter(
            (d) =>
            d["ECVersion"] == 2 &&
            d["Cat"] == "babies" &&
            d["Panel"] === "All" &&
            (d["DisaggregationCategory"] === "Panel" ||
                d["DisaggregationCategory"] === "All")
        );

        // console.log("filtered panel", filtered);

        let allVal = filtered.find((d) => d["DisaggregationCategory"] === "All");
        const parseTime = d3.utcParse("%m/%e/%y");
        const updateAsDate = parseTime(allVal.dateOfUpdate); // 2023-05-31
        // console.log("updateAsDate", updateAsDate);
        const formatTime = d3.utcFormat("%B %Y");
        // console.log(" allVal", allVal);
        const updateDate = d3.utcParse("%m/ %d, %Y");
        d3.select("#updateDate").html(formatTime(updateAsDate));

        let notAll = filtered.filter((d) => d["DisaggregationCategory"] !== "All");
        // console.log("notAll", notAll);

        let groupsByCat = d3.groups(notAll, (d) => d["DisaggregationValue"]);

        // console.log("groupsByCat panel", groupsByCat);

        // Sort the explicit order
        groupsByCat.sort((a, b) => {
            let indexA = sortOrderPanel.indexOf(a[0]);
            let indexB = sortOrderPanel.indexOf(b[0]);

            return indexA - indexB;
        });

        // console.log("allval test ", parseFloat(allVal["Value"]));

        let pieData = groupsByCat.map((d) => {
            return {
                name: d[1][0]["DisaggregationValue"],
                value: d[1][0]["Value"],
                origData: d[1][0],
                displayPct: parseFloat(d[1][0]["Value"]) / parseFloat(allVal["Value"]),
                allValue: parseFloat(allVal["Value"]),
                //                    overallPct: comboVal / parseFloat(forAll["Value"])
            };
        });

        let pieSubsData = d3.groups(notAll, (d) => d["DisaggregationValue"]);
        // console.log("pieSubsData", pieSubsData);

        pieData.forEach((d) => {
            d.Sub1Data = pieSubsData
                .find((n) => n[0] === d.name)[1]
                .filter((d) => d[0] !== "");
        });

        // console.log("pieData", pieData);

        filtered.pieData = pieData;

        return filtered;
    }

    function PreppedMonoData(fulldata) {
        //dont include conditions data for pies
        let filtered = fulldata.filter(
            (d) =>
            d["ECVersion"] == 2 &&
            d["Panel"] === "Monogenic" &&
            (d["DisaggregationCategory"] === "Monogenic risk" ||
                d["DisaggregationCategory"] === "All")
        );

        //console.log("filtered mono", filtered);

        let allVal = filtered.find((d) => d["DisaggregationCategory"] === "All");
        let notAll = filtered.filter((d) => d["DisaggregationCategory"] !== "All");
        // console.log("notAll", notAll);

        let groupsByCat = d3.groups(notAll, (d) => d["DisaggregationValue"]);

        // console.log("groupsByCat mono", groupsByCat);

        // Sort the explicit order
        groupsByCat.sort((a, b) => {
            let indexA = sortOrderMono.indexOf(a[0]);
            let indexB = sortOrderMono.indexOf(b[0]);

            return indexA - indexB;
        });

        //console.log("allval test ", parseFloat(allVal["Value"]));

        let pieData = groupsByCat.map((d) => {
            return {
                name: d[1][0]["DisaggregationValue"],
                //value: d[1][0]["Value"],
                value: d3.sum(d[1].map((d) => parseFloat(d.Value))),
                // origData: d[1][0],
                origData: d[1][0],
                displayPct: d3.sum(d[1].map((d) => parseFloat(d.Value))) /
                    parseFloat(allVal["Value"]),
                allValue: parseFloat(allVal["Value"]),
                //                    overallPct: comboVal / parseFloat(forAll["Value"])
            };
        });

        let pieSubsData = d3.groups(
            notAll,
            (d) => d["DisaggregationValue"],
            (d) => d["Sub1_Value"]
        );
        // console.log("pieSubsData", pieSubsData);

        pieData.forEach((d) => {
            d.Sub1Data = pieSubsData
                .find((n) => n[0] === d.name)[1]
                .filter((d) => d[0] !== "");
        });

        // console.log("pieData", pieData);

        filtered.pieData = pieData;

        return filtered;
    }

    function PreppedED1Data(fulldata) {
        //dont include conditions data for pies
        let filtered = fulldata.filter(
            (d) =>
            d["ECVersion"] == 1 &&
            d["Panel"] === "All" &&
            (d["DisaggregationCategory"] === "risk" ||
                d["DisaggregationCategory"] === "All")
        );

        //console.log("filtered mono", filtered);

        let allVal = filtered.find((d) => d["DisaggregationCategory"] === "All");
        let notAll = filtered.filter((d) => d["DisaggregationCategory"] !== "All");
        // console.log("notAll", notAll);

        let groupsByCat = d3.groups(notAll, (d) => d["DisaggregationValue"]);

        // console.log("groupsByCat mono", groupsByCat);

        // Sort the explicit order
        groupsByCat.sort((a, b) => {
            let indexA = sortOrderEC1.indexOf(a[0]);
            let indexB = sortOrderEC1.indexOf(b[0]);

            return indexA - indexB;
        });

        //console.log("allval test ", parseFloat(allVal["Value"]));

        let pieData = groupsByCat.map((d) => {
            return {
                name: d[1][0]["DisaggregationValue"],
                //value: d[1][0]["Value"],
                value: d3.sum(d[1].map((d) => parseFloat(d.Value))),
                // origData: d[1][0],
                origData: d[1][0],
                displayPct: d3.sum(d[1].map((d) => parseFloat(d.Value))) /
                    parseFloat(allVal["Value"]),
                allValue: parseFloat(allVal["Value"]),
                //                    overallPct: comboVal / parseFloat(forAll["Value"])
            };
        });

        let pieSubsData = d3.groups(
            notAll,
            (d) => d["DisaggregationValue"],
            (d) => d["Sub1_Value"]
        );
        // console.log("pieSubsData", pieSubsData);

        pieData.forEach((d) => {
            d.Sub1Data = pieSubsData
                .find((n) => n[0] === d.name)[1]
                .filter((d) => d[0] !== "");
        });

        // console.log("pieData EC1", pieData);

        filtered.pieData = pieData;

        return filtered;
    }

    function PreppedT1dData(fulldata) {
        //dont include conditions data for pies
        let filtered = fulldata.filter(
            (d) =>
            d["ECVersion"] == 2 &&
            d["Panel"] === "T1D" &&
            (d["DisaggregationCategory"] === "T1D Concern" ||
                d["DisaggregationCategory"] === "All")
        );

        //console.log("filtered t1d", filtered);

        let allVal = filtered.find((d) => d["DisaggregationCategory"] === "All");
        let notAll = filtered.filter((d) => d["DisaggregationCategory"] !== "All");
        //console.log("notAll", notAll);

        let groupsByCat = d3.groups(notAll, (d) => d["DisaggregationValue"]);

        // console.log("sortOrdert1d", sortOrdert1d);

        // Sort the explicit order
        groupsByCat = groupsByCat.sort((a, b) => {
            let indexA = sortOrdert1d.indexOf(a[0]);
            let indexB = sortOrdert1d.indexOf(b[0]);

            // console.log("a", a);
            // console.log("b", b);

            return indexA - indexB;
        });

        //console.log("groupsByCat T1d", groupsByCat);

        let pieData = groupsByCat.map((d) => {
            return {
                name: d[1][0]["DisaggregationValue"],
                value: d[1][0]["Value"],
                origData: d[1][0],
                displayPct: parseFloat(d[1][0]["Value"]) / parseFloat(allVal["Value"]),
                allValue: parseFloat(allVal["Value"]),
                //                    overallPct: comboVal / parseFloat(forAll["Value"])
            };
        });

        // console.log("pieData", pieData);

        let pieSubsData = d3.groups(
            notAll,
            (d) => d["DisaggregationValue"],
            (d) => d["Sub1_Value"]
        );
        // console.log("pieSubsData", pieSubsData);

        pieData.forEach((d) => {
            d.Sub1Data = pieSubsData
                .find((n) => n[0] === d.name)[1]
                .filter((d) => d[0] !== "");
        });

        //console.log("pieData", pieData);

        filtered.pieData = pieData;

        return filtered;
    }

    function PreppedTwoPlusRaceData(fulldata) {
        let filtered = fulldata.filter(
            (d) =>
            d["ECVersion"] == 2 &&
            d["Panel"] === "All" &&
            (d["DisaggregationCategory"] === "more than one" ||
                d["DisaggregationCategory"] === "race and/or ethnicity" ||
                d["DisaggregationCategory"] === "All")
        );

        let allVal = filtered.find((d) => d["DisaggregationValue"] === "All");
        // console.log("allVal ", allVal);
        let notAll = filtered.filter((d) => d["DisaggregationValue"] !== "All");
        let twoPlusVal = filtered.find(
            (d) => d["DisaggregationValue"] === "More than one race and/or ethnicity"
        );

        //console.log("twoPlusVal", twoPlusVal);
        // notAll.forEach(
        //   (d) => (d.pctVal = parseFloat(d.Value) / parseFloat(allVal.Value))
        // );
        // console.log("filtered PreppedTwoPlusRaceData", filtered);

        // notAll.sort((a, b) => b.pctVal - a.pctVal);

        var grouped = d3.group(notAll, (d) => d["DisaggregationValue"]);
        const nested = Array.from(grouped, ([key, values]) => ({
            key,
            values,
        }));
        //console.log("nested PreppedTwoPlusRaceData", nested);

        const onlySubs = nested.filter((d) => d.key !== "More than one race and/or ethnicity");

        const withPctAdded = onlySubs.map((d) => {
            //   console.log("d in nested for each", d);
            let comboval = d.values.filter(
                (n) => n["DisaggregationCategory"] === "more than one"
            )[0].Value;
            //console.log("comboval", comboval);

            // putting this in d.values[0] rather than just d.values not ideal, but saves needing to reformat bar data intake
            d.values[0].instCount = parseFloat(comboval);
            d.values[0].pctVal = d.values[0].instCount / parseFloat(twoPlusVal.Value);
            d.values[0].twoPlusCt = parseFloat(twoPlusVal.Value);
            // give more than one cat to parent
            d.values[0].twoPlusCat = d.values[1].DisaggregationCategory
            return d;
        });

        // // const culled = onlySubs.map((d) => d);
        // console.log("withPctAdded", withPctAdded);

        const culled = withPctAdded.map((d) => {
            // console.log("d in culled for each", d);
            // Create a shallow copy of the object
            let newd = {
                ...d,
            };
            // Create a shallow copy of the values array
            newd.values = [...newd.values];
            //only send in the first with added percents and instcount
            newd.values = newd.values.slice(0, 1);

            //   d.values[0].instCount = d.values.instCount;
            //   d.values[0].pctVal = d.values.pctVal;
            return newd;
        });
        //console.log("culled", culled);

        //    culled.sort((a, b) => b.values[0].pctVal - a.values[0].pctVal);
        //
        culled.sort((a, b) => {
            let indexA = sortOrderRace.indexOf(a.key);
            let indexB = sortOrderRace.indexOf(b.key);

            //console.log("a", a);
            // console.log("b", b);

            return indexA - indexB;
        });

        return culled;
    }
    //this

    function PreppedRaceEthData(fulldata) {
        let filtered = fulldata.filter(
            (d) =>
            d["ECVersion"] == 2 &&
            d["Panel"] === "Monogenic" &&
            (d["DisaggregationCategory"] === "race and/or ethnicity" ||
                d["DisaggregationCategory"] == "more than one" ||
                d["DisaggregationCategory"] === "All")
        );

        //console.log("filtered", filtered);

        let allVal = filtered.find((d) => d["DisaggregationCategory"] === "All");

        // console.log("allVal", allVal);

        let groupsByCat = d3.groups(filtered, (d) => d["DisaggregationValue"]);

        // console.log("groupsByCat", groupsByCat);

        groupsByCat.forEach((d) => {
            d[1].push(allVal);
            //console.log(" d", d);

            let forSolo = d[1]?.find(
                (d) => d["DisaggregationCategory"] === "race and/or ethnicity"
            );
            //console.log("forSolo", forSolo);

            let forCombo = d[1]?.find(
                (d) => d["DisaggregationCategory"] === "more than one"
            );
            //console.log("forCombo", forCombo);

            let forAll = d[1]?.find((d) => d["DisaggregationCategory"] === "All");
            //console.log("forAll", forAll);

            //
            //        if (forAll !== undefined) {
            //            console.log("forAll", forAll["Value"]);
            //            allVal = parseFloat(forAll["Value"]);
            //        }

            let soloVal;
            if (forSolo !== undefined) {
                // console.log("forSoloval", forSolo["Value"]);
                soloVal = parseFloat(forSolo["Value"]);
            }

            // console.log("soloVal", soloVal);

            let comboVal;
            let diffVal;
            if (forCombo !== undefined) {
                // console.log("forcomboval", forCombo["Value"]);
                comboVal = parseFloat(forCombo["Value"]);
                diffVal = parseFloat(forCombo["Value"]) - soloVal;
            }

            // console.log("comboVal", comboVal);
            //console.log("diffVal", diffVal);

            let remainVal;
            if (forAll !== undefined) {
                console.log("forRemainder", forAll["Value"]);
                remainVal = parseFloat(forAll["Value"]) - comboVal;
            }

            //console.log("remainVal", remainVal);
            // console.log("comboVal/allVal", comboVal / parseFloat(forAll["Value"]));

            d.pieData = [
                {
                    name: "solo",
                    value: soloVal,
                    origData: forSolo,
                    displayPct: soloVal / parseFloat(forAll["Value"]),
                    overallPct: comboVal / parseFloat(forAll["Value"]),
                    allValue: parseFloat(allVal["Value"]),
                    //                    pct: soloVal/allVal
        },
                {
                    name: "comboDiff",
                    value: diffVal,
                    origData: comboVal,
                    displayPct: diffVal / allVal,
        },
                {
                    name: "remainder",
                    value: remainVal,
        },
        //                diff: d[1].find(d => d['DisaggregationCategory'] ==='Race/Eth combo').Value - d[1].find(d => d['DisaggregationCategory'] ==='Race/Eth solo').Value,
        //                remainder: d[1].find(d => d['DisaggregationCategory'] ==='All').Value - d[1].find(d => d['DisaggregationCategory'] ==='Race/Eth combo').Value
      ];
        });

        // Assuming 'dataArray' is your array of arrays
        groupsByCat.sort((a, b) => {
            //console.log("a", a);
            // Find the 'comboDiff' object in each inner array
            let comboDiffA = a.pieData.find(
                (item) => item.name === "comboDiff"
            ).value;
            let comboDiffB = b.pieData.find(
                (item) => item.name === "comboDiff"
            ).value;

            // Compare their values to sort
            return comboDiffB - comboDiffA;
        });

        groupsByCat = groupsByCat.filter(
            (d) => d[0] !== "All" && d[0] !== "More than one race and/or ethnicity"
        );

        return groupsByCat;
    }





    function PreppedMutExRaceData(fulldata) {
        //dont include conditions data for pies
        let filtered = fulldata.filter(
            (d) =>
            d["ECVersion"] == 2 &&
            d["Panel"] === "All" &&
            (d["DisaggregationCategory"] === "race and/or ethnicity" ||
                d["DisaggregationCategory"] === "All")
        );

        // console.log("filtered mut ex race", filtered);

        let allVal = filtered.find((d) => d["DisaggregationCategory"] === "All");
        let notAll = filtered.filter((d) => d["DisaggregationCategory"] !== "All");
        //console.log("notAll", notAll);

        let groupsByCat = d3.groups(notAll, (d) => d["DisaggregationValue"]);

        // console.log("groupsByCat solor arce", groupsByCat);

        groupsByCat.sort(
            (a, b) => parseFloat(b[1][0].Value) - parseFloat(a[1][0].Value)
        );

        //    console.log("sortOrderRace", sortOrderRace);

        // Sort the explicit order
        groupsByCat.sort((a, b) => {
            let indexA = sortOrderRace.indexOf(a[0]);
            let indexB = sortOrderRace.indexOf(b[0]);
            return indexA - indexB;
        });

        // console.log("groupsByCat T1d", groupsByCat);

        let pieData = groupsByCat.map((d) => {
            return {
                name: d[1][0]["DisaggregationValue"],
                value: d[1][0]["Value"],
                origData: d[1][0],
                displayPct: parseFloat(d[1][0]["Value"]) / parseFloat(allVal["Value"]),
                allValue: parseFloat(allVal["Value"]),
                //                    overallPct: comboVal / parseFloat(forAll["Value"])
            };
        });

        // console.log("pieData", pieData);

        let pieSubsData = d3.groups(
            notAll,
            (d) => d["DisaggregationValue"],
            (d) => d["Sub1_Value"]
        );
        // console.log("pieSubsData", pieSubsData);

        pieData.forEach((d) => {
            d.Sub1Data = pieSubsData
                .find((n) => n[0] === d.name)[1]
                .filter((d) => d[0] !== "");
        });

        // console.log("pieData", pieData);

        filtered.pieData = pieData;

        return filtered;
    }

    function makePie(containerdiv, data, cat, val, colorrange) {
        // console.log("dta in pies", data);
        //    let height= 500;
        const width = 500;

        const height = Math.min(width, 500);
        const radius = Math.min(width, height) / 2;

        const arc = d3
            .arc()
            .innerRadius(0)
            .outerRadius(radius - 1);

        const pie = d3
            .pie()
            .padAngle(1 / radius)
            .sort(null)
            .value((d) => d[val]);

        const color = d3
            .scaleOrdinal()
            .domain(data.map((d) => d[cat]))
            .range(colorrange);

        const pieholder = d3
            .select(containerdiv)
            .append("div")
            // TODO changing the id to specific to chart and class to pieholder messes up bounds
            .attr("class", "col col-10 pieholder")
            .attr("id", "pieholder");

        let detailTriangle = d3
            .select(containerdiv)
            .append("div")
            .attr("class", "col col-2 col-md-2 triangle");

        let triangleStroke = detailTriangle
            .append("div")
            .attr("class", "col col-2 col-md-2 triangle-stroke");

        const tooltip = pieholder
            .append("div")
            .attr("class", "tooltip")
            .style("position", "absolute")
            .style("z-index", "10")
            .style("opacity", "0")
            .style("left", "0px")
            .style("top", "0px");

        const svg = pieholder
            .append("svg")
            .attr("viewBox", [-width / 2, -height / 2, width, height])
            .attr("style", "max-width: 100%; height: auto;");

        // const defs = svg
        // .append("defs")
        // .append("filter")
        // .attr("id", "strokeGlow")
        // .attr("y", "-10")
        // .attr("x", "-10")
        // .attr("width", "250")
        // .attr("height", "150")

        //     defs.append("feOffset")
        //     .attr("in", "StrokePaint")
        //     .attr("dx", "0")
        //     .attr("dy", "0")
        //     .attr("result", "centeredOffset");

        //     defs.append("feGaussianBlur")
        //     .attr("in", "centeredOffset")
        //     .attr("stdDeviation", "2")
        //     .attr("result", "blur1");

        //     defs.append("feGaussianBlur")
        //     .attr("in", "centeredOffset")
        //     .attr("stdDeviation", "5")
        //     .attr("result", "blur2");

        //     defs.append("feGaussianBlur")
        //     .attr("in", "centeredOffset")
        //     .attr("stdDeviation", "15")
        //     .attr("result", "blur3");

        //    const feMerge= defs.append("feMerge")

        //    feMerge.append("feMergeNode")
        //    .attr("in", "blur1")

        //    feMerge.append("feMergeNode")
        //    .attr("in", "blur2")

        //    feMerge.append("feMergeNode")
        //    .attr("in", "blur3")

        //    feMerge.append("feMergeNode")
        //    .attr("in", "SourceGraphic")

        // svg
        //     .append("rect")
        //     //      .attr("width", width)
        //     //      .attr("height", height)
        //     .attr("width", "100%")
        //     .attr("fill", "pink");

        const pieWedges = svg
            .append("g")
            .attr("class", "pieg")
            .selectAll()
            .data(pie(data))
            .join("path")
            .attr("fill", (d) => color(d.data[cat]))
            .attr("stroke", "#d6d6d6")
            .attr("d", arc);
        //.append("title");

        pieWedges
            .on("mousemove", function (event) {
                //var offset = $(this).parents(holderdiv).offset();

                //console.log("tooltip", $('.tooltip'));
                //				console.log("tooltip height", $('.tooltip').height());
                //

                let holderRect = pieholder.node().getBoundingClientRect();

                // Calculate the correct position by subtracting the container's offset
                let tooltipX = event.clientX - holderRect.left + 20; // Adding some offset for better visibility
                let tooltipY = event.clientY - holderRect.top - 80; // Adjusting Y position

                tooltip.style("left", tooltipX + "px").style("top", tooltipY + "px");

                // tooltip.style("left", (event.clientX + 20) + "px")
                //     .style("top", (event.clientY - 80) + "px");
            })

            .on("mouseenter", function (d) {
                let thisdata = d3.select(this).data()[0];

                // console.log("mouseenter");
                // console.log("thisdata", thisdata);

                // console.log("d for tooltip fill", d);

                tooltip.transition().duration(800).style("opacity", 1);

                tooltip.html(`<span>${
          thisdata.data.name
        }: <b>${pctFormat(thisdata.data.displayPct)}</b></span><br/><span><i>(${countFormat(thisdata.data.value)} of ${countFormat(thisdata.data.allValue)} ${thisdata.data.origData.Cat})</i></span>
`);
            })
            .on("mouseleave", function () {
                d3.select(containerdiv)
                    .selectAll(".legenditem")
                    .transition()
                    .duration(500)
                    .ease(d3.easePolyOut)
                    .style("font-weight", "");

                tooltip.transition().duration(600).delay(55).style("opacity", 0);
                tooltip.style("left", "0px").style("top",  "0px");
            });

        function makelegend(parentdiv, legenddata) {
            // console.log("parentdiv", parentdiv);
            // console.log("legenddata", legenddata);
            // console.log("parentdiv id", d3.select(parentdiv).attr("id"));

            let pieCat = legenddata[0].data.origData.DisaggregationCategory;

            function legLabel(pieCat) {
                if (pieCat === "Panel") {
                    return "Group combinations";
                } else if (pieCat === "Monogenic risk" || pieCat === "risk") {
                    return "Results";
                } else {
                    return pieCat;
                }
            }

            let parentID = d3.select(parentdiv).attr("id");
            //   console.log("legenddata", legenddata);
            let legendholder = d3
                .select(parentdiv)
                .select(".legendPlaceholder")
                .append("div")
                .attr("class", "legend row small");

            legendholder
                .append("text")
                .html("<b>" + legLabel(pieCat) + ":</b>")
                .attr("class", "text-primary pb-1");

            let legenditem = legendholder
                .selectAll("div")
                // .data(legenddata.reverse())
                .data(pieCat === "race and/or ethnicity" ? legenddata : legenddata.reverse())
                .enter()
                .append("div")
                .attr("class", "col col-md-3 legendentry small d-flex");

            legenditem
                .append("span")
                .attr("class", "legendbullet pe-2 flex-shrink-1")
                .attr("style", (d) => "color:" + color(d.data[cat]))
                .html("&#11044;");

            legenditem
                .append("span")
                .attr("class", "legendcat flex-grow-1")
                //                .html((d) =>
                //                    d.data[cat] === "comboDiff" ?
                //                    "this race/ethnicity and other(s)" :
                //                    d.data[cat] === "solo" ?
                //                    "this race/ethnicity only" :
                //                    d.data[cat]
                //                );
                .html((d) => d.data[cat]);


            legendholder
                .append("text")
                .html(
                    parentID === "panelresults" ?
                    "<i>Hover for detail</i>" :
                    "<i>Click result category for detail</i>"
                )
                .style("color", "#007c8f")
                .attr("class", "small");

            legenditem.on("click", function (d) {
                // console.log("d in legend click", d);
                // console.log("this in legend click", d3.select(this));

                let thisdata = d3.select(this).data()[0];
                // console.log("thisdata", thisdata);

                let piewedges = d3.select(parentdiv).selectAll(".pieg path");
                // console.log("piewedges", piewedges);

                let pairPieWedge = piewedges.filter((n) => {
                    //   console.log("n in legend click", n);
                    return n.data.name === thisdata.data.name;
                });
                // console.log("pairPieWedge ", pairPieWedge);
                // console.log("containerdiv.parentNode ", containerdiv.parentNode);

                pieClick(
                    pairPieWedge,
                    "#" + d3.select(containerdiv.parentNode.parentNode).attr("id")
                );
            });
        }
        //makelegend(containerdiv, pie(data));

        //cTODO can probably remove if statement below

        //    if (
        //      data[0]["origData"]["DisaggregationCategory"] === "Monogenic risk" ||
        //      data[0]["origData"]["DisaggregationCategory"] === "T1D Concern" ||
        //      data[0]["origData"]["DisaggregationCategory"] === "race and/or ethnicity"
        //    ) {
        //   console.log("data in leg check", data);
        makelegend(containerdiv.parentNode.parentNode, pie(data));
        //    }
        //      else {
        //         console.log("containerdiv", containerdiv);
        //         console.log("containerdiv.parentNode.parentNode", containerdiv.parentNode.parentNode);
        //             console.log("data in leg check for race", data);
        //            console.log("containerdiv.parentNode (singlepie)", containerdiv.parentNode);
        ////                 console.log("containerdiv.parentNode.id",containerdiv.parentNode.attr.id);
        ////         console.log("containerdiv.parentNode.attr('id')",containerdiv.parentNode.attr('id'));
        ////
        //        let thisparent = containerdiv.parentNode
        //        console.log("(thisparent.attr('id')", d3.select(thisparent).attr('id'))
        //
        //        //only make a legend for one chart since all others in the set are the same here
        //        if(d3.select(thisparent).attr('id') === 'singlepie1'){
        //         makelegend(containerdiv.parentNode.parentNode, pie(data).filter(d => d.data.name !== 'remainder'));
        //        }
        //    }

        return svg.node();
    }

    //TODO rename tihs to racepie
    function makeRacePieholders(containerdiv, data, inputRange) {
        //    data.forEach((d) => {
        // console.log("data in pieholder", data);

        let legendPlaceholder = d3
            .select(containerdiv)
            .append("div")
            .attr("class", "legendPlaceholder col col-12 ");

        let holderdiv = d3
            .select(containerdiv)
            .selectAll(".singlepie")
            //        .attr("class", "col col-3  border singlepie")
            .data(data)
            .enter()
            .append("div")
            .attr("class", "col col-6 col-md-3  pt-2 singlepie")
            .attr("id", (d, i) => {
                //  console.log('d in get index', d)
                // console.log('i in get index',i)

                if (i) {
                    return "singlepie" + i;
                }
            })
            .append("div")
            .attr("class", "row p-2 h-100 d-flex align-content-end");

        //h6 had been here

        let titleblock = holderdiv
            .append("h6")
            .attr("class", " text-primary col col-12 w-100 pb-1 text-center")
            .html((d) => d[0])
            .style("line-height", "1.1em");

        holderdiv
            .append("strong")
            .attr("class", "col col-12 w-100 pb-2 text-center")
            .html((d) => {
                //console.log('d in get pct',d)
                return (100 * d.pieData[0].overallPct).toFixed(2) + "%";
            });

        holderdiv.each(function () {
            //console.log('d in holderdiv each', d)
            //console.log("this", this);
            //console.log("this data", this.__data__);
            makePie(this, this.__data__.pieData, "name", "value", raceComboRange);
        });

        // console.log(" holderdiv", holderdiv);

        holderdiv._groups[0].forEach(function (n, i) {
            //console.log("holderdiv each", this);
            // console.log("holderdiv each n", n);
            // console.log("holderdiv each i", i);
            if (i > 0) {
                d3.select(n).select(".legend").remove();
            }
        });

        //makelegend(holderdiv)
    }

    function resultsPieHolders(containerdiv, data, inputrange) {
        // console.log("data in results", data);

        if (containerdiv === "#racepieholder") {
            d3.select("#demogTotal").html(
                countFormat(
                    data.filter((d) => d["DisaggregationCategory"] === "All")[0].Value
                )
            );
        }

        d3.select(containerdiv)
            .append("span")
            .attr("class", "col col-12 w-100 pb-3 ")
            //todo this title could get mucked with sort order.. remove, all or use pie?
            .html(() => {
                let totalsdata = data.filter(
                    (d) => d["DisaggregationCategory"] === "All"
                )[0].Value;

                // console.log(
                //   'data.filter(d => d["DisaggregationCategory"] === "All")',
                //   data.filter((d) => d["DisaggregationCategory"] === "All")
                // );
                // console.log("totalsdata", totalsdata);
                // total not included above pie for race/eth, they wanted a single total for both map and pie for demographics. Keep the row there for whitespace
                if (containerdiv !== "#racepieholder") {

                    //labels on longer using category of enrolled or screened
                    return `<b><span class='fs-6'>Total ${data[0].Cat}:</span> <span class=' fs-4'>${countFormat(data.filter((d) => d["DisaggregationCategory"] === "All")[0].Value)} </span></b>`

                }
            })
            .style("color", "#007c8f");

        let legendPlaceholder = d3
            .select(containerdiv)
            .append("div")
            .attr("class", "legendPlaceholder col col-12 ");

        let holderdiv = d3
            .select(containerdiv)
            .append("div")
            .attr("class", "col col-5 col-md-4  pt-2 singlepie")
            .append("div")
            .attr("class", "row py-2  h-100 d-flex align-content-start");

        if (containerdiv !== "#panelresults") {
            let allPanels = d3
                .select(containerdiv)
                .append("div")
                .attr("class", " col col-7 col-md-7")
                .attr("id", "subCats")
                .append("div")
                .attr("class", "row");

            allPanels.append("h4")
                .style('display', 'none');
        }

        let resultColorRange = inputrange;

        holderdiv.each(function () {
            //  console.log('d in holderdiv each', d)
            //   console.log("this", this);
            //   console.log("this data", this.__data__);
            makePie(this, data.pieData, "name", "value", resultColorRange);
        });

        //      function identified() {

        let segment = holderdiv.selectAll(".pieg path").on("click", function (d) {
            // console.log("clicked");
            // console.log("d3.select(this)", d3.select(this));
            d3.selectAll(".pieg").style("pointer-events, none");
            let pieWedge = d3.select(this);
            // console.log('piewedgedata in on  click', d3.select(this).data())
            //  console.log('piewedgedata in on  click', pieWedge.data()[0]['data'])

            if (
                pieWedge.data()[0]["data"]["origData"]["DisaggregationCategory"] !==
                "Panel"
            ) {
                pieClick(pieWedge, containerdiv);
            }
        });
    }

    const pieClick = function (pieWedge, containerdiv) {
        // console.log("containerdiv in click", containerdiv);
        // console.log("pieWedge in click", pieWedge);
        // console.log("pieWedge.classed(active)?", pieWedge.classed("active"));
        if (pieWedge.classed("active") === true) {
            //deselection

            d3.selectAll(".pieg path").classed("active", false);

            //   d3.select(containerdiv).selectAll(".triangle").style("border", "2px solid red");
            d3.select(containerdiv).selectAll(".triangle").classed("active", false);

            // remove wedge specific details
            d3.select(containerdiv)
                .selectAll(".onecat")
                .transition()
                .duration(600)
                .style("opacity", 0)
                .on("end", function () {
                    d3.select(this).remove();
                });

            d3.select(containerdiv)
                .select("#subCats")
                .select(".row")
                .select("h4")
                .transition()
                .duration(600)
                .style("opacity", 0)
                .on("end", function () {
                    d3.select(this).html("")
                        .style('display', 'none');
                });
        } else {
            d3.selectAll(".pieg path").classed("active", false);
            pieWedge.classed("active", true);
            pieWedge.moveToFront();
            d3.select(containerdiv).select(".triangle").classed("active", true);
            // Retrieve the color of the clicked wedge
            const wedgeColor = pieWedge.style("fill");
            //   console.log("wedgeColor", wedgeColor);

            function convertRgbToRgba(rgb, alpha) {
                // Extract the RGB values using a regular expression
                const rgbValues = rgb.match(/\d+/g);

                // Ensure we have exactly 3 values (R, G, B)
                if (rgbValues.length !== 3) {
                    throw new Error("Invalid RGB format");
                }

                // Convert the RGB values to an RGBA string with the specified alpha
                const [r, g, b] = rgbValues;
                return `rgba(${r}, ${g}, ${b}, ${alpha})`;
            }

            d3.select(containerdiv)
                .select(".triangle")
                .style(
                    "background",
                    `linear-gradient(90deg, ${convertRgbToRgba(
            wedgeColor,
            ".71"
          )} 0%, ${convertRgbToRgba(
            wedgeColor,
            ".41"
          )} 40%, rgb(255 255 255) 100%)`
                );

            //                   console.log('this ', d3.select(this));
            //                     console.log('this parent ', d3.select(this).parentNode);
            // console.log("this pieWedge for parent ", pieWedge);
            // console.log("this parent2 ", d3.select(pieWedge.parentNode));

            // console.log("this parent3 ", pieWedge.select(this.parentNode));

            // console.log("this parent4", pieWedge.node().parentNode);
            const thisdata = pieWedge.data();

            // console.log("thisdata[0].startAngle", thisdata[0].startAngle);

            // Calculate midpoint angle in degrees
            const midpointAngle =
                ((thisdata[0].startAngle + thisdata[0].endAngle) / 2) * (180 / Math.PI);

            // console.log(" midpointAngle ", midpointAngle);

            // console.log("thisdata ", thisdata);
            // Calculate rotation needed to align midpoint to 90 degrees
            // Note: Subtracting from 90 to rotate clockwise to the correct position
            let rotation = 90 - midpointAngle;

            // Calculate the translation values
            const translateX = 10 * Math.cos(midpointAngle);
            const translateY = 10 * Math.sin(midpointAngle);

            // console.log(" rotation ", rotation);
            //

            //select the parent(whole pie) to rotate
            d3.select(pieWedge.node().parentNode)
                .transition()
                .duration(600)
                .ease(d3.easeQuadOut)

                // .style('transform', 'rotate(45deg)')

                // .style(d => 'transform', 'rotate(' + rotation + 'deg )')
                // .style( 'transform', d => 'rotate(' + rotation + 'deg )')
                .attr("transform", "rotate(" + rotation + ")")
                // .style("transform", `translate(${translateX}px, ${translateY}px)`)
                .on("end", function () {
                    d3.select(this.parentNode)

                        .interrupt()
                        .style("pointer-events, all");
                });

            d3.select(containerdiv).selectAll(".onecat").remove();

            d3.select(containerdiv)
                .select("#subCats")
                .select(".row")
                .select("h4")
                .style('display', 'block')
                .style("opacity", 1)

                .html((d) => {
                    // console.log("d where I want cat", thisdata);

                    if (thisdata[0].data.name === "Positive/Not normal result") {
                      
                        let sub2msg =  thisdata[0].data.Sub1Data[0][1][0].Sub2_Cat ?`<br/><small class="d-inline-block fs-6 fw-bold pt-2">${thisdata[0].data.Sub1Data[0][1][0].Sub2_Cat }</small>` : "";
                        
                        return thisdata[0].data.name + sub2msg;
                    } else {
                        //TO DO this is likely best for final- put 'conditions identified' and any other parent to all columns header here once data restructured
                        //return thisdata[0].data.name  + thisdata[0].data.origData?.Sub2_Cat;
                        let sub2msg = thisdata[0].data.origData.Sub2_Cat ?
                            '<br/><small class="d-inline-block fs-6 pt-2">' +
                            thisdata[0].data.origData.Sub2_Cat +
                            "</small>" :
                            "";
                        return thisdata[0].data.name + sub2msg;
                    }
                });

            let onecat = d3
                .select(containerdiv)
                .select("#subCats")
                .select(".row")
                //TODO proper data update and transition here
                .selectAll("div")

                //todo see if keeping this. Creates inconsistent strcture for labels of race subcats
                .data(() => {
                    return thisdata[0].data.Sub1Data.length > 0 ?
                        thisdata[0].data.Sub1Data : [thisdata[0].data.name];
                })
                .enter()
                .append("div")
                .attr("class", () =>
                    thisdata[0].data.Sub1Data.length > 1 ?
                    "col onecat border-light border-end mt-2" :
                    "col onecat "
                );

                onecat.each(function (d) {
                    // console.log("d in onecat each", d);
                    
                     if (d[1][1]) {
                        //this is the label for groups on positive results
                        d3.select(this).append("h5").html((d) => d[0] );
                    }
                    
    
                    // d will be race/eth group label only if there's no sub1, otherwise it will be the data with subs
                    //              console.log( 'parentdata', this.parentNode.data());
                    if (d === "More than one race and/or ethnicity") {
                        // console.log(typeof splitbar); // 
                        splitbar(
    
    
                            PreppedTwoPlusRaceData(d3data),
                            String(containerdiv) + " #subCats .onecat",
                            //onecat,
                            300,
                            "DisaggregationValue",
                            "DisaggregationValue",
                            "pctVal",
                            "",
                            raceRange2,
                            sortOrderRace
                        );
                    } else {
                        
                                        d3.select(this)
                    .append("ul")
                    .selectAll("li")
                    .data((d) => d[1])
                    .enter()
                    .append("li")
                    .attr("class", (d) => {
                        //                    console.log(" d to set class", d);
                        //                    console.log(" this.parentNode ",  d3.select(pieWedge.parentNode));
                        //                   console.log(" this.parentNode2 ",  pieWedge.select(this.parentNode));
                        //                    let parentData = d3.select(this.parentNode.parentNode).data();
                        //                    console.log(" parentData ", parentData);
                        return thisdata[0].data.Sub1Data.length > 1 ? "small" : "notsmall_li";
                    })
                    .html((d) => {
                        if (d["Sub2_Value"]) {
                            return (
                                d["Sub2_Value"] +
                                (d["Sub2_Cat"] && d["Sub2_Value"] && d["Value"] ?
                                    ":<br/><b>" + d["Value"] + "</b>" :
                                    "")
                            );
                        } else if (d.DisaggregationCategory === "race and/or ethnicity") {
                            return (
                                "Identified by parents as " + d.DisaggregationValue + " only."
                            );
                        } else {
                            return "";
                        }
                    });
    
                //remove so no bullet on entry holder for bar chart
                d3.selectAll(".notsmall_li")
                    .filter((d) => {
                        // console.log("d in remove li", d);
                        return d === "w";
                    })
                    .remove();
    
                    }
    
                   
            
                });

          
        }
    };

    resultsPieHolders("#panelresults", PreppedPanelData(d3data), panelRange);
    resultsPieHolders("#monoresults", PreppedMonoData(d3data), monoRange);
    resultsPieHolders("#t1dresults", PreppedT1dData(d3data), t1dRange);
    resultsPieHolders("#racepieholder", PreppedMutExRaceData(d3data), raceRange);
    resultsPieHolders("#ec1_results", PreppedED1Data(d3data), EC1Range);
    return d3data;
}

// getdata();

returnedBounds.then((counties) => {
    function mapLocCode(d) {
        return d.properties.GEOID;
        //   return d.id;
    }

    //fips code location in data file
    let dataLocCode = "countyName";

    initialMap(d3.select("#mapHolder"), counties, dataLocCode);
    const returnedData = getdata();
    returnedData.then((retdata) => {
        let mapData = retdata.filter(
            (d) =>
            d.DisaggregationCategory === "County" ||
            d.DisaggregationCategory === "State"
        );
        updateMap(d3.select("#mapHolder"), mapData);
    });
});
